import { Avatar, AvatarProps, styled } from '@mui/material';
import { ReactElement } from 'react';

const StyledAvatar = styled(Avatar, {
    shouldForwardProp: prop => prop !== 'styleType',
})<{ styleType?: 'cover' | 'contain' }>(({ styleType }) => ({
    '& > img': {
        ...(styleType === 'cover' && {
            width: '100%',
            height: '100%',
        }),
        ...(styleType === 'contain' && {
            width: 'auto',
            height: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
        }),
    },
}));

const cleanString = (value: string): string => {
    return value.replace(/[^0-9a-z]/gi, '');
};

export interface PoolAvatarProps extends AvatarProps {
    firstName: string;
    lastName?: string;
    styleType?: 'contain' | 'cover'; // default: 'contain'
}

export const PoolAvatar = (props: PoolAvatarProps): ReactElement => {
    const { firstName, lastName, styleType, ...avatarProps } = props;

    if (firstName.length === 0) {
        throw new Error('firstName must not be empty');
    }

    let initials: string | null = null;
    if (!avatarProps.src && !avatarProps.srcSet) {
        const cleanFirstName = cleanString(firstName);
        const cleanLastName = lastName && cleanString(lastName);

        if (cleanFirstName && cleanLastName) {
            initials = cleanFirstName.substring(0, 1) + cleanLastName.substring(0, 1);
        } else {
            initials = cleanFirstName.substring(0, Math.min(2, cleanFirstName.length));
        }
    }

    return (
        <StyledAvatar {...avatarProps} alt={`${firstName} ${lastName ?? ''}`} styleType={styleType}>
            {initials}
        </StyledAvatar>
    );
};
